export default {
  common: {
    currentLanguage: 'The current language is "{{lng}}"',
  }
};
